import DesktopItemList from './DesktopItemList';
import MobileItemList from './MobileItemList';

import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';

import { ItemCard } from './types';
import { FetchingDataStatus } from '~/types/utilities';

export default function InfinityItemList({
  itemCount,
  items,
  fetchingStatusOfItem,
  onNavigateToItem,
  onLoadNextPage,
  onSetHeaderDisplay,
  onSetItemListRef,
}: {
  items: Array<ItemCard>;
  itemCount: number;
  fetchingStatusOfItem: FetchingDataStatus;
  onLoadNextPage: () => void;
  onNavigateToItem: (storeId: string, itemId: string) => void;
  onSetHeaderDisplay: (val: boolean) => void;
  onSetItemListRef: (list: any) => void;
}) {
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);
  return isLargerThan768 ? (
    <DesktopItemList
      fetchingStatusOfItem={fetchingStatusOfItem}
      itemCount={itemCount}
      items={items}
      onLoadNextPage={onLoadNextPage}
      onNavigateToItem={onNavigateToItem}
      onSetHeaderDisplay={onSetHeaderDisplay}
      onSetItemListRef={onSetItemListRef}
    />
  ) : (
    <MobileItemList
      fetchingStatusOfItem={fetchingStatusOfItem}
      itemCount={itemCount}
      items={items}
      onLoadNextPage={onLoadNextPage}
      onNavigateToItem={onNavigateToItem}
      onSetHeaderDisplay={onSetHeaderDisplay}
      onSetItemListRef={onSetItemListRef}
    />
  );
}
